<template>
  <div class="websiteTree">
    <div v-for="item in list" :key="item.id" class="websiteTree__item">
      <div class="websiteTree__item-row" :class="{'is-active': item.checked}" @click="loadCategoryList(item)">
        <div class="info">
          <el-checkbox v-model="item.checked" :disabled="!item.checked && item.disabled" @change="(val) => onCheckboxChange(val,item)" />
          <div class="label" style="display: block">{{ item.domain }}</div>
        </div>
        <div class="icon">
          <template>
            <i v-show="!item.isShowNextLevel" class="el-icon-arrow-right" />
            <i v-show="item.isShowNextLevel" class="el-icon-arrow-down" />
          </template>
        </div>
      </div>
      <!-- v-show="item.isShowNextLevel"  -->
      <div v-show="item.isShowNextLevel">
        <div v-loading="true" style="height: 80px" v-if="item.childrenLoading"></div>
        <div v-for="child in item.children" :key="child.id" class="websiteTree__item-category">
          <div class="websiteTree__item-row" :class="{'is-active': child.checked}" style="padding-left: 23px" @click="showNextLevel(child)">
            <div class="info">
              <el-checkbox v-model="child.checked" :disabled="!child.checked && item.disabled" @change="(val) => onCheckboxChange(val,item)" />
              <div class="label">{{ child.title }}</div>
            </div>
            <div class="icon">
              <template v-if="child.children">
                <i v-show="!child.isShowNextLevel" class="el-icon-arrow-right" />
                <i v-show="child.isShowNextLevel" class="el-icon-arrow-down" />
              </template>
            </div>
          </div>
          <div v-if="child.children" v-show="child.isShowNextLevel">
            <div v-for="child1 in child.children" :key="child1.id">
              <div class="websiteTree__item-row" :class="{'is-active': child1.checked}" style="padding-left: 46px" @click="showNextLevel(child1)">
                <div class="info">
                  <el-checkbox v-model="child1.checked" :disabled="!child1.checked && item.disabled" @change="(val) => onCheckboxChange(val,item)" />
                  <div class="label">{{ child1.title }}</div>
                </div>
                <div class="icon">
                  <template v-if="child1.children">
                    <i v-show="!child1.isShowNextLevel" class="el-icon-arrow-right" />
                    <i v-show="child1.isShowNextLevel" class="el-icon-arrow-down" />
                  </template>
                </div>
              </div>
              <div v-if="child1.children" v-show="child1.isShowNextLevel">
                <div v-for="child2 in child1.children" :key="child2.id">
                  <div class="websiteTree__item-row" :class="{'is-active': child2.checked}" style="padding-left: 69px">
                    <div class="info">
                      <el-checkbox v-model="child2.checked" :disabled="!child2.checked && item.disabled" @change="(val) => onCheckboxChange(val,item)" />
                      <div class="label">{{ child2.title }}</div>
                    </div>
                    <div class="icon"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  data() {
    return {
      list: []
    }
  },
  props: {
    websiteList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    initChildren(children) {
      return children.map(child => {
        if (!_.has(child,'checked')) {
          child.checked = false
        }
        if (child.children) {
          child.children = this.initChildren(child.children)
          if (!_.has(child,'isShowNextLevel')) {
            child.isShowNextLevel = false
          }
        }
        return child
      })
    },
    initList(websiteList) {
      websiteList = JSON.parse(JSON.stringify(websiteList))
      this.list = websiteList.map(i => {
        if (!_.has(i,'checked')) {
          i.checked = false
        }
        if (!_.has(i,'isShowNextLevel')) {
          i.isShowNextLevel = false
        }
        if (i.children) {
          i.children = this.initChildren(i.children)
        }
        return i
      })
    },
    onCheckboxChange(val, item) {
      console.log('onCheckboxChange', val, item)
      item.disabled = val
    },
    async loadCategoryList(item) {
      if (item.children) {
        item.isShowNextLevel = !item.isShowNextLevel
      } else {
        item.isShowNextLevel = true
        this.$set(item, 'childrenLoading', true)
        item.childrenLoading
        let res = await my_http_ajax('/api/fish/category-list', 'get', {
          site_id: item.id
        })
        console.log('res', res);
        this.$set(item, 'childrenLoading', false)
        if (res.status == 1) {
          item.children = res.data
          this.initList(this.list)
        } else {
          item.isShowNextLevel = false
          res.msg && this.$message?.warning(res.msg)
        }
      }
    },
    showNextLevel(item) {
      console.log('showNextLevel', item)
      if (item.children) {
        item.isShowNextLevel = !item.isShowNextLevel
      }
    }
  },
  computed: {
    selectedData() {
      const category = []
      function getCategoryId(item) {
        let id = ''
        item?.children?.forEach(item => {
            item.checked ? id = item.id : getCategoryId(item) !== '' ? id = getCategoryId(item) : null
        })
        return id
      }
      this.list.forEach(i => {
        let data = {}
        if(i.disabled) {
          data.site_id = i.id
          data.url = i.domain
        }
        if(!i.checked) {
          data.material_category_id = getCategoryId(i)
        }
        if(_.has(data,'site_id')) {
          category.push(data)
        }
      })
      return {category}
    }
  },
  watch: {
    websiteList: {
      handler: function(val) {
        console.log('watch', val);
        this.initList(val)
      },
      deep: true,
      immediate: true
    },
    selectedData: {
      handler: function(val) {
        console.log('selectedData',val);
        this.$emit('selectedDataChange', val)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.websiteTree {
  background-color: #fff;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  max-height: 428px;
  .websiteTree__item-row {
    display: flex;
    cursor: pointer;
    height: 32px;
    line-height: 32px;
    overflow: hidden;
    width: 100%;
    &:hover {
      background-color: #F5F5F5;
    }
    &.is-active {
      border-radius: 4px;
      background-color: #EEEEEE;
    }
    .info {
      flex:1;
      padding-left: 12px;
      display: flex;
      overflow: hidden;
      color: #606266;
      font-size: 14px;
      font-weight: 500;
    }
    .icon{
      color: #C0C4CC;
      margin-left: 5px;
      margin-right: 10px;
      width: 16px;
      flex: 0 0 16px;
    }
  }
  .label {
    margin-left: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
}
</style>
